import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import WhyUs from './pages/WhyUs';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';

const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/"                   element={<Home />} />
        <Route path="/about"              element={<About />} />
        <Route path="/services"           element={<Services />} />
        <Route path="/services/:slug"     element={<ServiceDetail />} />
        <Route path="/why-us"             element={<WhyUs />} />
        <Route path="/testimonials"       element={<Testimonials />} />
        <Route path="/contact"            element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;
